<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import moment from 'moment';

export default {
   page: {
      title: "Outsource Token Calls",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: { Layout, PageHeader },
   data() {
      return {
         loading: false,
         title: "Outsource Token Calls",
         items: [
            {
               text: "Outsource Token Calls",
               active: true,
            },
         ],
         token: "",
         calls: [],
         counters: [],
         pagination: {},
         from: null,
         to: null,
         total: null,
         listing_length: 10,
         keyword: "",
         counter_id: "",
         date: moment().format("YYYY-MM-DD"),
         active_page_url: null,
      };
   },
   created() {
      this.fetchCounters();
      this.fetchCalls();
   },
   methods: {
      getToken() {
         if (localStorage.getItem('medicino_lab')) {
            var medicino_lab = JSON.parse(localStorage.getItem('medicino_lab'));
            if (medicino_lab.token) {
               this.token = medicino_lab.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },

      buildQuery() {
         let url = "lab/outsourceTokenCalls?limit=" + this.listing_length
            + "&date=" + this.date
            + "&keyword=" + encodeURIComponent(this.keyword || '');
         if (this.counter_id) {
            url += "&counter_id=" + this.counter_id;
         }
         return url;
      },

      fetchCounters() {
         this.getToken();
         this.$axios
            .get("lab/counters?limit=100&status=1&keyword=", {
               headers: { Authorization: "Bearer " + this.token },
            })
            .then((res) => {
               var responseData = res.data.data;
               this.counters = responseData.counters.data || [];
            })
            .catch(() => {
               this.counters = [];
            });
      },

      fetchCalls(page_url = null) {
         this.getToken();

         let url = this.buildQuery();
         page_url = page_url || url;

         this.active_page_url = page_url;
         this.loading = true;
         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.calls = responseData.calls.data;
               this.from = responseData.calls.from;
               this.to = responseData.calls.to;
               this.total = responseData.calls.total;
               this.pagination = responseData.calls.links;
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
      },

      onFilterChange() {
         this.fetchCalls();
      },
   },
};
</script>

<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- Listing length and filters starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-4">
                        <div class="listing-length">
                           <label>Show
                              <select class="form-control" v-model="listing_length" @change="onFilterChange()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>
                     </div>
                     <div class="col-sm-12 col-md-8">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="onFilterChange()" />
                           </label>
                        </div>
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="counter_id" @change="onFilterChange()">
                                 <option value="">All Counters</option>
                                 <option v-for="counter in counters" :key="counter.id" :value="counter.id">
                                    {{ counter.counter_name }}
                                 </option>
                              </select>
                           </label>
                        </div>
                        <div class="listing-filter me-2">
                           <label>
                              <input type="date" class="form-control" v-model="date" @change="onFilterChange()" />
                           </label>
                        </div>
                     </div>
                  </div>
                  <!----- Listing length and filters ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Token</th>
                              <th>Counter</th>
                              <th>Call Date</th>
                              <th>Created On</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(calls.length)">
                           <tr v-for="call in calls" :key="call.id">
                              <td>{{ call.token || '-' }}</td>
                              <td>{{ call.counter_name || '-' }}</td>
                              <td>{{ call.call_date | formatDate }}</td>
                              <td>
                                 <span v-if="call.created_at">{{ call.created_at | formatDateTime }}</span>
                                 <span v-else>-</span>
                              </td>
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="4" class="text-center">
                                 {{ loading ? 'Loading...' : 'No outsource token calls found' }}
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->
                  <caption v-if="Boolean(calls.length)" class="float-start mt-4 d-block d-lg-inline">
                     Showing {{ from }} to {{ to }} of {{ total }} entries
                  </caption>
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
                        v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link"
                           @click.prevent="fetchCalls(page.url + '&limit=' + listing_length + '&date=' + date + '&keyword=' + encodeURIComponent(keyword || '') + (counter_id ? '&counter_id=' + counter_id : ''))">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length - 1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{ page.label }}</span>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
